import { useState } from "react";
import { toast } from "sonner";
import { RefreshCcw } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export const DemoReset = () => {
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (!window.confirm(t("adm.demo_confirm"))) return;
    setBusy(true);
    try { await api.post("/admin/demo/reset"); toast.success(t("adm.demo_done")); } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <div className="cx-card rounded-2xl p-5 mb-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="admin-demo-reset">
      <div className="flex-1">
        <div className="text-white font-semibold">{t("adm.demo_title")}</div>
        <p className="text-xs text-slate-400 mt-1">{t("adm.demo_desc")}</p>
      </div>
      <button onClick={run} disabled={busy} data-testid="admin-demo-reset-btn" className="cx-metal rounded-full px-5 py-2.5 text-sm font-semibold flex items-center gap-2 disabled:opacity-50">
        <RefreshCcw className={`w-4 h-4 ${busy ? "animate-spin" : ""}`} />{t("adm.demo_btn")}
      </button>
    </div>
  );
};
